import { ENV } from '@sitegen/common/constants/environments';

export const OVERLAY_SDK_LOCATION = {
    [ENV.DEV]: 'https://uat-overlay.ubisoft.com/overlay-connect-integration/widget.js',
    [ENV.PROD]: 'https://overlay.ubisoft.com/overlay-connect-integration/widget.js'
};

export const HEADER_HEIGHT = 51.7;
